import React, { useState, useEffect, useRef, useCallback } from "react";
import AxiosInstance from "../AxiosInstance";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Layout from "./Layout";
import ToastNotification from "../ToastNotification";
import { useNavigate } from "react-router-dom";
import { Button,Row,Col } from "react-bootstrap";
import { ArrowLeftCircle } from "react-bootstrap-icons";
import Pagination from "../Pagination";

const TimesheetStatus = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [employeeList, setEmployeeList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10; // or any number you want per page

  const toastRef = useRef(null);
  const empMap = new Map();

  employeeList.forEach(emp => {
    if (empMap.has(emp.employee_code)) {
      empMap.get(emp.employee_code).count += 1;
    } else {
      empMap.set(emp.employee_code, { ...emp, count: 1 });
    }
  });
  const uniqueEmployees = Array.from(empMap.values());
  // Fetch status function wrapped in useCallback
  const fetchStatus = useCallback(async () => {
    try {
      const firstDayOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
      const formattedMonth = firstDayOfMonth.toISOString(); // or toLocaleDateString if needed

      const response = await AxiosInstance.get(`/admin/timesheet-defaulters`, {
        params: { month: formattedMonth },
      });

      setEmployeeList(response.data);
    } catch (error) {
      toastRef.current?.showToast("Failed to fetch data", "danger");
    }
  }, [selectedDate]);  // Add selectedDate as dependency

  // Fetch data on component mount or when the selectedDate changes
  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);  // Now the dependency is the memoized fetchStatus function

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentEmployees = uniqueEmployees.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <Layout heading="Timesheet Defaulters">
      <Row className="mb-3">
        <Col xs={12}>
          <Button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
            <ArrowLeftCircle /> 
          </Button>
        </Col>
      </Row>
      <div className="container">
        <div className="row mb-3 align-items-center">
          <div className="col-12 col-md-auto">
            <DatePicker
              selected={selectedDate}
              onChange={(date) => {
                setSelectedDate(date);
                setCurrentPage(1);
              }}              
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              className="form-control"
              placeholderText="Select month and year"
            />
          </div>
        </div>

        <div className="table-responsive d-block d-md-none" style={{ maxHeight: "300px", overflowY: "auto" }}>
          <table className="table table-hover text-center align-middle table-striped">
            <thead className="table-primary">
              <tr>
                <th>#</th>
                <th className="text-start">Employee Code</th>
                <th className="text-start">Employee Name</th>
                <th className="text-start">Total Weeks Missed</th>
              </tr>
            </thead>
            <tbody>
              {currentEmployees.length > 0 ? (
                currentEmployees.map((emp, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td className="text-start">{emp.employee_code}</td>
                    <td className="text-start">
                      {emp.emp_name.replace(/\b\w/g, char => char.toUpperCase())}
                    </td>
                    <td className="text-start">{emp.count || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-muted">No defaulters for this month</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Desktop view: full table without scroll */}
        <div className="table-responsive d-none d-md-block">
          <table className="table table-hover text-center align-middle table-striped">
            <thead className="table-primary">
              <tr>
                <th>#</th>
                <th className="text-start">Employee Code</th>
                <th className="text-start">Employee Name</th>
                <th className="text-start">Total Weeks Missed</th>
              </tr>
            </thead>
            <tbody>
              {currentEmployees.length > 0 ? (
                currentEmployees.map((emp, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td className="text-start">{emp.employee_code}</td>
                    <td className="text-start">
                      {emp.emp_name.replace(/\b\w/g, char => char.toUpperCase())}
                    </td>
                    <td className="text-start">{emp.count || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-muted">No defaulters for this month</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={Math.ceil(uniqueEmployees.length / recordsPerPage)}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
      <ToastNotification ref={toastRef} />
    </Layout>
  );
};

export default TimesheetStatus;
